import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DSTheme } from '../../styles/themes/types';
import { PROJECT_STATUS } from '../../interfaces/project';

type StylesProps = {
  status: PROJECT_STATUS;
};

const useStyles = makeStyles<DSTheme, StylesProps>((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '30px',
    borderRadius: '16px',

    background: ({ status }) => {
      switch (status) {
        case PROJECT_STATUS.LIVE:
          return 'linear-gradient(95.6deg, #FF06E6 -40.11%, #713BDB 100%), #713BDB';
        case PROJECT_STATUS.REVIEW:
          return '#713BDB';
        default:
          return '#808191';
      }
    },
  },
  content: {
    textTransform: 'capitalize',
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#ffffff',
  },
}));

type ProjectStatusProps = {
  status: PROJECT_STATUS;
};

const ProjectStatus: React.FC<ProjectStatusProps> = ({ status }) => {
  const classes = useStyles({ status });

  return (
    <div className={classes.root}>
      <div className={classes.content}>{status}</div>
    </div>
  );
};

export default ProjectStatus;
